import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CommittesService } from '../../services/committes-service';
import { AddCommitteComponent } from '../add-committe/add-committe.component';
import { GetCommitteDetailsComponent } from '../get-committe-details/get-committe-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-committes',
  templateUrl: './get-committes.component.html',
  styleUrls: ['./get-committes.component.scss'],
})
export class GetCommittesComponent extends BaseComponent implements OnInit {

  form :FormGroup 

  constructor(
    public service: CommittesService,
    route: Router,
    private diag: NbDialogService,
    private fb:FormBuilder,
    private toast: NbToastrService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    nameAR: [''],
    code: ['']
  });
}


clearFilter(){
  this.form.controls['nameAR'].setValue('');
  this.form.controls['code'].setValue('');
  this.loadEntitiesWithFilter('')
}

handleSearch(){
let searchArr = [];
  
  if(this.form.value.nameAR.trim()){
    const name = this.form.value.nameAR.trim();
    this.form.controls['nameAR'].setValue(name);
    searchArr.push(`nameAR:${name}`)
  }
  if(this.form.value.code.trim()){
    const code = this.form.value.code.trim();
    this.form.controls['code'].setValue(code);
    searchArr.push(`code:${code}`)
  }

  if(searchArr.length == 0){
this.toast.danger('برجاءاختيار الاسم او الكود لاتمام عمليةالبحث', 'رساله تحذيرية');
    return
  }

  this.loadEntitiesWithFilter(searchArr.join(','))
}



  addNew() {
    this.diag
      .open(AddCommitteComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(GetCommitteDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddCommitteComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
